<template>
  <transition name="fadefast">
    <div class="landscape d-flex align-items-center justify-content-center" v-if="!isPortrait && !override">

      <noise/>

      <div class="ls-wrapper text-center d-flex flex-column align-items-center">

        <div class="icon-wrap">
          <svg xmlns:xlink="http://www.w3.org/1999/xlink" class="phone" viewBox="0 0 22 40"
               xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-323, -130)" stroke="#000000" stroke-width="2">
                <g transform="translate(298, 116)">
                  <path
                    d="M43.7003,15.4 L27.8563,15.4 C26.9843,15.4 26.2783,16.114 26.2783,16.994 L26.2783,50.805 C26.2783,51.686 26.9843,52.4 27.8563,52.4 L43.7003,52.4 C44.5723,52.4 45.2783,51.686 45.2783,50.805 L45.2783,16.994 C45.2783,16.114 44.5723,15.4 43.7003,15.4 M44.4393,18.531 C44.9023,18.531 45.2783,18.833 45.2783,19.204 L45.2783,48.595 C45.2783,48.967 44.9023,49.269 44.4393,49.269 L27.1173,49.269 C26.6543,49.269 26.2783,48.967 26.2783,48.595 L26.2783,19.204 C26.2783,18.833 26.6543,18.531 27.1173,18.531 L44.4393,18.531"></path>
                </g>
              </g>
            </g>
          </svg>

          <svg xmlns:xlink="http://www.w3.org/1999/xlink" class="rotate" viewBox="0 0 74 67"
               xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.3">
              <g transform="translate(-297, -116)" stroke="#000000" stroke-width="2.8">
                <g transform="translate(298, 116)">
                  <g transform="translate(0, 0.8)">
                    <path
                      d="M67.2784,27.6 C65.1834,12.356 51.7974,0.6 35.5964,0.6 C20.1474,0.6 7.2594,11.288 4.2784,25.497"></path>
                    <polyline points="0.2784 45.6 3.8494 37.6 12.2784 40.989"></polyline>
                    <path
                      d="M4.2784,37.6 C6.4984,52.867 19.7954,64.6 35.8674,64.6 C51.5564,64.6 64.6004,53.419 67.2784,38.686"></path>
                    <polyline points="71.2784 20.6 67.7074 28.6 59.2784 25.211"></polyline>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>

        <span class="adobe-clean-serif">
          This experience is best viewed in portrait orientation.
          <br>Please rotate your phone vertically.
        </span>

      </div>
    </div>
  </transition>
</template>

<script>
  import { mapState } from 'vuex'
  import { TweenMax, Power2 } from 'gsap'
  import Noise from '@/components/demos/Noise'

  export default {
    name: 'landscape-message',
    components: { Noise },
    props: {
      override: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isPortrait: true
      }
    },
    computed: {
      ...mapState( {
        formFactor: state => state.device.formFactor
      } )
    },
    watch: {
      isPortrait () {
        if ( this.isPortrait ) {
          TweenMax.killTweensOf( '.rotate' )
          if ( this.formFactor === 'Smartphone' ) TweenMax.to( '#AdobePrimaryNav', 0.5, { y: 0 } )
        } else {
          this.$nextTick( () => {
            if ( this.formFactor === 'Smartphone' ) TweenMax.to( '#AdobePrimaryNav', 0.5, { y: -80 } )
            TweenMax.to( '.rotate', 3, {
              repeat: -1,
              repeatDelay: 1,
              rotation: 360,
              ease: Power2.easeInOut
            } )
          } )
        }
      }
    },
    methods: {
      onOrientationChange () {
        let orientation = 0
        if ( 'orientation' in window ) {
          orientation = window.orientation
        } else if ( 'screen' in window && 'orientation' in window.screen ) {
          orientation = window.screen.orientation.angle
        }

        if ( orientation % 180 !== 0 ) {
          this.isPortrait = false
        } else {
          this.isPortrait = true
        }

        this.$emit( 'orientationChange', this.isPortrait )
      }
    },
    created () {
      window.addEventListener( 'orientationchange', this.onOrientationChange )
    },
    mounted () {
      this.$nextTick( () => {
        if ( window.innerWidth > window.innerHeight ) {
          this.onOrientationChange()
        }
      } )
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/global/the_goods";
  @import "~@/assets/scss/global/classes/transitions";

  .landscape {
    position         : fixed;
    top              : 0;
    left             : 0;
    width            : 100%;
    height           : 100%;
    background       : $white;
    color            : $black;
    transform-origin : top left;
    z-index          : 25;
    transform        : translateZ(5px);

    .icon-wrap {
      position : relative;
      width    : 96px;
      height   : 96px;

      .phone {
        position : relative;
        top      : 23px;
        width    : 27.5px;
        height   : 50px;
      }

      .rotate {
        position         : absolute;
        top              : 5.5px;
        left             : 0;
        width            : 94px;
        height           : 85px;
        transform-origin : 50% 50%;
      }
    }

    span {
      font-style : italic;
      margin-top : 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LandscapeMessage.vue